



































import {
  defineComponent,
  PropType,
  ref,
  computed,
} from '@vue/composition-api';
import { UserCreditData, HomeDailogTypeEnum } from '@/pages/home/types';
import { refreshComponentInstanceKey, hideSkWebviewTabbarMask, showSkWebviewTabbarMask } from '@/pages/home/utils';
import BackPopup from '@/pages/home/components/DailogController/BackPopup/index.vue';
import { Visit } from '@/enums/tianjiangConf';
import {
  TianJiangMarket, PageLoadedPopup, CreditAmountAlterPopup, RepayOverdueAlterPopup,
} from './dailogs-loader';


export interface DailogControllerRef {
  gotoLeavePageWithBackPopup: () => void;
  refreshCurrentDailogShow: () => void;
}

/** 刷新弹窗组件实例key */
const refreshDailogInstanceKey = (type: HomeDailogTypeEnum) => `${type}_${refreshComponentInstanceKey()}`;

export default defineComponent({
  name: 'DailogController',
  components: {
    TianJiangMarket,
    PageLoadedPopup,
    CreditAmountAlterPopup,
    RepayOverdueAlterPopup,
    BackPopup,
  },
  props: {
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
    pageLoadedDailogType: {
      type: String as PropType<HomeDailogTypeEnum>,
      required: true,
    },
  },
  setup(props) {
    /** 天降红包组件实例key */
    const tianJiangComponentKey = ref('');
    /** 退出挽留弹窗的展示状态 */
    const backPopupVisible = ref(false);
    /** 退出挽留弹窗组件实例key */
    const backPopupComponentKey = ref('');
    /** 首页打开时的广告-组件实例key */
    const pageLoadedPopupComponentKey = ref('');
    /** 天降红包访问类型 */
    const tianJiangVisit = computed(
      () => (props.userCreditData.creditStatus ? Visit.Quality : Visit.Tagless),
    );

    /** 弹窗展示 */
    const onShowDailog = (type: HomeDailogTypeEnum) => {
      /** 容器化webview-tabbar遮罩层展示 */
      showSkWebviewTabbarMask();
    };
    /** 弹窗关闭：广告无数据、点击关闭弹窗 */
    const onCloseDailog = (type: HomeDailogTypeEnum) => {
      /** 容器化webview-tabbar遮罩层隐藏 */
      hideSkWebviewTabbarMask();
    };

    return {
      HomeDailogTypeEnum,
      tianJiangVisit,
      tianJiangComponentKey,
      backPopupVisible,
      backPopupComponentKey,
      pageLoadedPopupComponentKey,

      /**
       * 退出首页流程
       * 先check是否展示首页挽留弹窗，若是则展示弹窗，否则直接退出首页
       */
      gotoLeavePageWithBackPopup: () => {
        backPopupVisible.value = true;
        /** 每次退出拦截，请求刷新退出挽留广告数据 */
        backPopupComponentKey.value = refreshDailogInstanceKey(HomeDailogTypeEnum.BACK_POPUP);
      },
      refreshCurrentDailogShow: () => {
        if (props.pageLoadedDailogType === HomeDailogTypeEnum.TIAN_JIANG_MARKET) {
          tianJiangComponentKey.value = refreshDailogInstanceKey(
            HomeDailogTypeEnum.TIAN_JIANG_MARKET,
          );
        } else if (props.pageLoadedDailogType === HomeDailogTypeEnum.PAGE_LOADED_POPUP) {
          pageLoadedPopupComponentKey.value = refreshDailogInstanceKey(
            HomeDailogTypeEnum.PAGE_LOADED_POPUP,
          );
        }
      },
      onShowDailog,
      onCloseDailog,
    };
  },
});
